import "@story/story_assets/dom_extend";
import "@story/story_assets/modal/modal_dialog"
import "@story/story_assets/modal/modal_gallery"
import "@story/story_assets/slide";
import "@story/story_assets/snippets";

import "./components/autocomplete";
import "./components/quantity";
import "./components/confirm";

document.addEventSelectorListener("change", "form [data-submit='change']", function (event, target) {
	if (target.getAttribute("type") == "radio" && !target.checked) {
		// Do not do anything, if radio has been unchecked.
		return;
	}

	target.classList.add("sending-request");
	// document.querySelector(".category-products, .news-articles").classList.add("sending-request");

	var form = target.closest("form");
	form.trigger("submit");
});
